import { Message  } from 'element-ui'

const versionKey = 'version-id';

// 获取本地存储的版本号
export function getVersionId() {
  const versionId = localStorage.getItem(versionKey) ? localStorage.getItem(versionKey) : '';
  return versionId
}
// 存储版本号
export function setVersionId(version) {
  return localStorage.setItem(versionKey,version)
}

export function handleVersion() {
 if (process.env.NODE_ENV !== 'development') {

   window.getVersion = (version) => {
    //  console.log('正确的web版本是：', version);
     /** !getVersionId()含义为
      * null、''、undefined、0、false 等 "falsy" 值 → !getVersionId() 为 true
      * 其他非空字符串 → !getVersionId() 为 false
      * **/
     if (!getVersionId() || (getVersionId() && version !== getVersionId())) {
       Message.success({
         message: "发现新版本，自动更新中...",
         type: "success",
         // showClose: true,
         duration: 3000, // 3秒后关闭
         onClose: () => {
           // location.reload()  // location.reload(true) 在部分新版浏览器中已失效
           // window.location.href = window.location.href + '?reload=' + Date.now();
           // 兼容 macOS 所有浏览器强制完全绕过缓存
           window.location.href = window.location.href.split('?')[0] + '?reload=' + Date.now();
         }
       })
     }
     setVersionId(version) // 保存 以便下次使用判断
   }

 }
}

export function insertVersionFile() {
 if (process.env.NODE_ENV !== 'development') {
   const scriptCollection = document.getElementsByTagName('script');
   // 判断是否已经有version.js 文件，如果有，先删掉资源引入
   // const scriptAry =[...scriptCollection] // ie不支持这种写法（HTMLCollection 不是数组）
   const scriptAry = Array.from(scriptCollection);
   scriptAry.some((v) => {
     const flag = v.src.indexOf('version.js') !== -1;
     if (flag) {
       v.parentNode?.removeChild(v)
     }
     return flag
   });
   const versionScript = document.createElement('script')
   // versionScript.src = import.meta.env.VITE_BASE_PATH + '/version.js?v=' + new Date().getTime()
   versionScript.src = '/version.js?v=' + new Date().getTime();
   //document.getElementsByTagName('script')表示返回当前页面中所有 <script> 元素的集合
   const s = document.getElementsByTagName('script')[0];
   s.parentNode?.insertBefore(versionScript, s)
 }
}

handleVersion();



// // 检查版本更新
//  export async function checkVersion() {
//    // if (process.env.NODE_ENV === 'development') return;
//
//    try {
//      // 请求 version.json（避免缓存，加时间戳）
//      const res = await fetch(
//        `/version.json?v=${Date.now()}`,
//        { cache: 'no-cache',credentials: 'include' } // 强制绕过浏览器缓存
//      );
//      const data = await res.json();
//      const newVersion = data.webVersion;
//      console.log('正确的web版本是：', newVersion);
//
//      // 比对版本
//      if (!getVersionId() || (getVersionId() && newVersion !== getVersionId())) {
//        Message({
//          message: '发现新版本，即将自动更新...',
//          type: 'success',
//          duration: 2000, // 2秒后关闭
//          onClose: () => location.reload(),
//        });
//        location.reload()
//        setVersionId(newVersion); // 存储新版本
//      }
//    } catch (error) {
//      console.error('版本检测失败:', error);
//    }
//  }